import React, { useEffect, useState, useContext } from "react";
// import Logo from "../header/Logo";
import { FooterBase } from "@reusejs/react";
import { FooterNavItems, Context } from "services";
import Link from "next/link";
import LogoDarkSvg from "../../Icons/LogoDarkSvg";

export default function Footer() {
  const [navigation, setNavigation] = useState<any>();
  const { searchForm }: any = useContext(Context);

  const getNavigationItems = async () => {
    const data: any = FooterNavItems();
    setNavigation(data);
  };

  useEffect(() => {
    getNavigationItems();
  }, []);

  return (
    <FooterBase
      left={() => {
        return (
          <>
            <div className="text-white">
              <LogoDarkSvg />
            </div>
            <p className="text-gray-500 text-base pr-4">
              The most transparent way to find and bid for the property of your
              choice.
            </p>
            <div className="flex space-x-6">
              {navigation?.social.map((item: any) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-400 hover:text-blue-600"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
          </>
        );
      }}
      right={() => {
        return (
          <>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h4 className="text-sm font-semibold text-white tracking-wider uppercase">
                  Company
                </h4>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation?.company.map((item: any) => (
                    <li key={item.name}>
                      <Link href={item.href}>
                        <a
                          href={item.href}
                          onClick={(e) => {
                            if (item.name === "Property") {
                              searchForm.setField("asset_type", "");
                              searchForm.setField("sub_asset_type", "");
                              searchForm.setField("state", "");
                              searchForm.setField("city", "");
                              searchForm.setField("reserve_price", "");
                              searchForm.setField("institutes", "");
                              searchForm.setField("filter_by", "");
                              searchForm.setField("sort_by", "");
                              searchForm.setField("total", "");
                            }
                          }}
                          className="text-base text-gray-500 hover:text-blue-600"
                        >
                          {item.name}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h4 className="text-sm font-semibold text-white tracking-wider uppercase">
                  Properties
                </h4>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation?.properties.map((item: any) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className="text-base text-gray-500 hover:text-blue-600"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0 md:hidden ">
                <h4 className="text-sm font-semibold text-white tracking-wider uppercase whitespace-nowrap">
                  Help and support
                </h4>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation?.help.map((item: any) => (
                    <li key={item.name}>
                      <Link href={item.href}>
                        <a className="text-base text-gray-500 hover:text-blue-600">
                          {item.name}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0 md:hidden">
                <h4 className="text-sm font-semibold text-white tracking-wider uppercase">
                  Legal
                </h4>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation?.legal.map((item: any) => (
                    <li key={item.name}>
                      <Link href={item.href}>
                        <a className="text-base text-gray-500 hover:text-blue-600">
                          {item.name}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="hidden md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h4 className="text-sm font-semibold text-white tracking-wider uppercase">
                  Help and support
                </h4>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation?.help.map((item: any) => (
                    <li key={item.name}>
                      <Link href={item.href}>
                        <a className="text-base text-gray-500 hover:text-blue-600">
                          {item.name}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h4 className="text-sm font-semibold text-white tracking-wider uppercase">
                  Legal
                </h4>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation?.legal.map((item: any) => (
                    <li key={item.name}>
                      <Link href={item.href}>
                        <a className="text-base text-gray-500 hover:text-blue-600">
                          {item.name}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        );
      }}
      bottom={() => {
        return (
          <p className="text-base text-gray-400 text-center">
            &copy; 2022 Auctionbazaar.com(ARCA EMART PVT LTD) All rights
            reserved.
          </p>
        );
      }}
      leftArrangement="bg-slate-900"
      rightArrangement="mt-12 lg:mt-0 bg-slate-900"
      backgroundClasses="bg-slate-900"
      bottomArrangement="mt-12 border-t border-gray-200 bg-slate-900"
    />
  );
}
